// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/icon/iconfont/iconfont.css'
import './assets/icon/iconfont/iconfont.js'
import VueLazyload from 'vue-lazyload'
import axios from './config/axiosUtil'
import '../static/js/colorpicker'

//数学公式mathjax
import globalVariable from '../static/js/wangEditor/globalVariable'
import store from './vuex/store'
import infiniteScroll from "vue-infinite-scroll";     //无限滚动
import 'highlight.js/styles/monokai-sublime.css'    //代码高亮
import filters from './config/filter.js'
// import echarts from 'echarts'
import * as echarts from 'echarts';
import Contextmenu from "vue-contextmenujs"   // 自定义右键

import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'

import {
  Button,
  Breadcrumb,
  BreadcrumbItem,
  Carousel,
  CarouselItem,
  Cascader,
  Checkbox,
  CheckboxGroup,
  Collapse,
  CollapseItem,
  DatePicker,
  Dialog,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Form,
  FormItem,
  Input,
  InputNumber,
  Loading,
  Message,
  Notification,
  Option,
  Pagination,
  Popover,
  Progress,
  Radio,
  RadioButton,
  RadioGroup,
  Rate,
  Select,
  Skeleton,
  SkeletonItem,
  Slider,
  Step,
  Steps,
  Switch,
  Table,
  TableColumn,
  Timeline,
  TimelineItem,
  TimePicker,
} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
import MessageBox from 'element-ui/packages/message-box'
import Meta from 'vue-meta'
Vue.config.productionTip = false

Vue.use(Button)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Cascader)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)

Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(DatePicker)
Vue.use(Dialog)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Loading)
Vue.use(Option)
Vue.use(Pagination)
Vue.use(Popover)
Vue.use(Progress)
Vue.use(Radio)
Vue.use(RadioButton)
Vue.use(RadioGroup)
Vue.use(Rate)
Vue.use(Select)
Vue.use(Skeleton)
Vue.use(SkeletonItem)
Vue.use(Slider)
Vue.use(Step)
Vue.use(Steps)
Vue.use(Switch)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Timeline)
Vue.use(TimelineItem)
Vue.use(TimePicker)

Vue.use(Contextmenu);
Vue.use(preview,{
  // maxSpreadZoom: 1, // 控制预览图最大的倍数，默认是2倍，我这里改成了原图
  fullscreenEl: false, // 控制是否显示右上角全屏按钮
  // closeEl: false, // 控制是否显示右上角关闭按钮
  tapToClose: true, // 点击滑动区域应关闭图库
  shareEl: false, // 控制是否显示分享按钮
  // zoomEl: false, // 控制是否显示放大缩小按钮
  counterEl: false, // 控制是否显示左上角图片数量按钮
  arrowEl: true,  // 控制如图的左右箭头（pc浏览器模拟手机时）
  tapToToggleControls: true, // 点击应切换控件的可见性
  clickToCloseNonZoomable: true // 点击图片应关闭图库，仅当图像小于视口的大小时
})
Vue.prototype.axios = axios
Vue.prototype.$message = Message
Vue.prototype.$notify = Notification
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$echarts = echarts

Vue.use(Meta)
Vue.prototype.commonsVariable = globalVariable;
Vue.use(infiniteScroll);
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: require('../src/assets/loadingerror.jpg'),
  loading: require('../src/assets/play.gif'),
  attempt: 1
})

Vue.directive('title', {    // 单个修改标题
  inserted: function (el, binding) {
    document.title = el.dataset.title
    // console.log('bind', el)
  },
  unbind: function (el, binding) {
    // console.log('unbind')
    if (router.app._route.name !== 'articlePage' && router.app._route.name !== 'videodetail' && router.app._route.name !== 'Question') {
      document.title = '优卡思'
    }
    // console.log('unbind')
  }
})

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js